import { render } from "./OrganizationInvoice.vue?vue&type=template&id=1f90841e&scoped=true"
import script from "./OrganizationInvoice.vue?vue&type=script&lang=js"
export * from "./OrganizationInvoice.vue?vue&type=script&lang=js"

import "./OrganizationInvoice.vue?vue&type=style&index=0&id=1f90841e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f90841e"]])

export default __exports__